import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as provisioningPaths } from "@/types/api/provisioning/schema.gen"

const client = createApiClient<provisioningPaths>({
  baseUrl: `${env.VITE_API2_URL}/provisioning`
})

// Vanilla API client
export const $provisioningApiClient = client.vanillaClient

// React-Query client
export const $rqProvisioningApiClient = createClient(client.rqClient)
